
import React, {FC} from 'react';

import Post from './Post';
import {useSelected} from './useSelected';

import * as styles from './styles.module.scss';

type PostsProps = {
	slugs: string[]
}

const Posts: FC<PostsProps> = ({slugs}) => {
	const posts = useSelected(slugs);
	return (
		<div className={styles.wrapper}>
			{posts.map((post, i) => post && (
				<Post {...post} key={i} />
			))}
		</div>
	);
};

export default Posts;
